window.addEventListener("load", function () {
 
});